import { toSnakeCase } from "./text_functions";
import { v4 as uuidv4, v5 as uuidv5 } from 'uuid';

// Constants
import { defaultFoodUnit, foodUnitOptions } from "@/_constants/food";

// Utilities
import { roundNumber } from './number_functions';

// Interfaces
import { IRecipe } from '@/interfaces/recipe/recipe';
import { IMealOption, IUnit } from "@/interfaces/nutrition/nutrition_builder";


export const mapUnit = (unit: IUnit): IUnit => {
    const NAMESPACE = 'd2b1f8c0-3f4e-4c5a-9b6c-7d8e9f0a1b2c';
    const uuid = unit.uuid ?? foodUnitOptions.find((u: IUnit) => u.enum == toSnakeCase(unit.label))?.uuid ?? uuidv5(`${unit.label}:${unit.weight}`, NAMESPACE);
    return {
        uuid: uuid,
        label: unit.label,
        weight: unit.weight,
    };
}

export const mapDefaultUnit = (units: IUnit[]): IUnit =>
    units.find((u: IUnit) => u.uuid == defaultFoodUnit.uuid) ?? units[0];

export const calculateCalories = (
    protein: number,
    carbs: number,
    fat: number,
    decimalPlaces?: number
): number => {
    return roundNumber((protein * 4) + (carbs * 4) + (fat * 9), decimalPlaces ?? 1);
}

export const mapRecipeToMealOption = (recipe: IRecipe): IMealOption => {
    return {
        uuid: uuidv4(),
        recipe_id: recipe.id,
        serving_size: 1,
        calories: roundNumber(recipe.calories, 1),
        carbs: roundNumber(recipe.carbs, 1),
        protein: roundNumber(recipe.protein, 1),
        fat: roundNumber(recipe.fat, 1),
        fibre: roundNumber(recipe.fibre, 1),
        foods: recipe.ingredients.map(ingredient => ({
            _id: ingredient.source_ingredient_id,
            name: ingredient.name,
            protein: ingredient.macros.protein / 100 * ((ingredient.amount * ingredient.unit.weight) / recipe.servings),
            carbs: ingredient.macros.carbs / 100 * ((ingredient.amount * ingredient.unit.weight) / recipe.servings),
            fat: ingredient.macros.fat / 100 * ((ingredient.amount * ingredient.unit.weight) / recipe.servings),
            fibre: ingredient.macros.fibre / 100 * ((ingredient.amount * ingredient.unit.weight) / recipe.servings),
            calories: ingredient.macros.calories / 100 * ((ingredient.amount * ingredient.unit.weight) / recipe.servings),
            portion: ingredient.amount / recipe.servings,
            macros: {
                calories: ingredient.macros.calories,
                protein: ingredient.macros.protein,
                carbs: ingredient.macros.carbs,
                fat: ingredient.macros.fat,
                fibre: ingredient.macros.fibre,
                alcohol: ingredient.macros.alcohol ?? 0
            },
            unit: ingredient.unit,
            units: ingredient.units
        }))
    };
}